var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    {
      staticClass: "align-baseline",
      attrs: { "no-gutters": "true", dense: "true" },
    },
    [
      _c("v-col", { attrs: { cols: "2" } }, [
        _c("div", { staticClass: "h5" }, [
          _vm._v(_vm._s(_vm.service.toUpperCase())),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "v-col",
        { attrs: { cols: "3" } },
        [
          _c("v-text-field", {
            attrs: {
              value: _vm.pharmacist,
              placeholder: "Freiberufler",
              label: "Freiberufler",
              name: `${_vm.service}-pharmacist`,
              type: "number",
              min: "0",
              rules: _vm.pricingOverrideRules,
              "prepend-icon": "mdi-currency-eur",
            },
            on: {
              input: function ($event) {
                return _vm.$emit("update:pharmacist", $event)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-col",
        { staticClass: "ml-2", attrs: { cols: "3" } },
        [
          _c("v-text-field", {
            attrs: {
              value: _vm.margin,
              placeholder: "Margin",
              label: "Margin",
              name: `${_vm.service}-margin`,
              type: "number",
              min: "0",
              rules: _vm.pricingOverrideRules,
              "prepend-icon": "mdi-currency-eur",
            },
            on: {
              input: function ($event) {
                return _vm.$emit("update:margin", $event)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-col",
        { staticClass: "ml-auto", attrs: { cols: "3" } },
        [
          _c("v-text-field", {
            attrs: {
              value: _vm.totalPrice,
              placeholder: "Total price",
              label: "Total price",
              type: "number",
              name: `${_vm.service}-pharmacy`,
              rules: _vm.pricingOverrideRules,
              "prepend-icon": "mdi-currency-eur",
              readonly: "",
              disabled: "",
              filled: "",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }